<div class="list-view w-full h-full">
  <div class="widget-bg-color justify-end h-full rounded-xl">
    <!-- To show loading message, while http call is in progress -->
    <sp-loading-inprogress *ngIf="httpCallInProgress; else loadingComplete" [showSpinner]="true"></sp-loading-inprogress>
    <ng-template #loadingComplete>
      <ng-template [ngIf]="downloadData.length > 0" [ngIfElse]="empty">
        <sp-custom-generic-table [tableName]="'asset-history-'" [tableCols]="columns" [tableData]="downloadData" [actionColumn]="false"></sp-custom-generic-table>
      </ng-template>
      <ng-template #empty>
        <sp-blank-page [pageType]="pageType"></sp-blank-page>
      </ng-template>
    </ng-template>
  </div>
</div>
